@if (selectedNotification) {
<div class="col th-p notification-content-wrapper">
  <div class="row mt-2">
    <div class="col-md-12 px-3">
      <header class="top-box-shadow">
        <div class="columns is-gapless is-vcentered is-mobile">
          <figure class="has-text-centered hideMobileView">
            <i
              class="fa"
              [ngClass]="{
                'fa-angle-double-left':
                  !this.notificationComponent.viewNotificatonList,
                'fa-angle-double-right':
                  this.notificationComponent.viewNotificatonList
              }"
              (click)="hideNotificationList()"
            ></i>
          </figure>
          @if (!editedPostDetails) {
          <div class="column is-6">
            <h3 class="is-marginless is-clearfix">
              <span
                class="is-size-6 has-text-weight-semibold ellipsis"
                style="max-width: 80%; display: inline-block"
                title="{{ selectedNotification.post_name }}"
                >{{ selectedNotification.post_name }}
              </span>
              @if (selectedNotification.canEdit) {
              <a
                class="has-text-info has-tooltip-right"
                data-tooltip="Edit notification title"
                (click)="editPostName()"
              >
                <i class="pi pi-pen-to-square pad-0-10"></i>
              </a>
              }
              <small class="display-b is-size-8 text-clr-grey">{{
                selectedNotification.created_at | date : "MMM d, y h:mm a"
              }}</small>
            </h3>
          </div>
          }
          <!-- Post name update section -->
          @if (editedPostDetails) {
          <div class="column is-6">
            <div class="control edit-text-box">
              <input
                type="text"
                class="input"
                inputFocus
                placeholder="Type here..."
                size="{{ calcTextLength(editedPostDetails.post_name) }}"
                [(ngModel)]="editedPostDetails.post_name"
                (keyup.enter)="updatePostName(editedPostDetails)"
              />
              <div class="options">
                <a class="button is-small" (click)="cancelEditedPostName()"
                  >Cancel</a
                >
                <a
                  class="button is-link is-small mar-0-10"
                  (click)="updatePostName(editedPostDetails)"
                  >Save</a
                >
              </div>
            </div>
          </div>
          }
          <div class="column">
            <div class="desk-view">
              <!-- Resend button and info button part -->
              @if (selectedNotification.canEdit &&
              !domElementControl.showCreateNewSubPost) {
              <a
                class="desk-icon has-tooltip-left"
                data-tooltip="Create new post"
                (click)="openCreateNewSubPostPanel()"
              >
                <button class="button is-small is-link">
                  <i class="fa-solid fa-circle-plus"></i>&nbsp;&nbsp; New Post
                </button>
              </a>
              }&nbsp;
              <!-- <a class="desk-icon tooltip has-tooltip-left" data-tooltip="Resend Text">
                    <i class="fa fa-paper-plane is-size-6" aria-hidden="true"></i>
                  </a> -->
              <a
                class="desk-icon has-tooltip-left"
                data-tooltip="Following users info"
                (click)="showRealTimeUpdate()"
              >
                <i class="pi pi-users is-size-6" aria-hidden="true"></i> &nbsp;
                <!-- <span class="tag is-small is-rounded is-info"> 2 </span> -->
              </a>
              &nbsp;&nbsp;
              <a
                class="desk-icon mobileViewBtn"
                data-tooltip="Close active notification"
                (click)="closeActiveMobileView()"
              >
                <i class="fa fa-times is-size-6" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
        <!-- Create New Sub post Section -->
        <div
          class="box create-sub-post"
          [ngClass]="{ 'post-animate': domElementControl.showCreateNewSubPost }"
        >
          <article class="media">
            <div class="media-content">
              <div
                class="field post-attach-file"
                style="margin-bottom: 1.85rem"
              >
                <label class="label">Attachement File</label>
                <div class="control profile-img">
                  @if (!preUploadedFile) {
                  <div>
                    <img
                      [src]="'../../../assets/images/empty-state-attach.png'"
                    />
                  </div>
                  } @if (preUploadedFile && preUploadedFile?.file_path) {
                  <div>
                    @if (preUploadedFile?.file_type ==='image') {
                    <img [src]="preProfileUrl + preUploadedFile.file_path" />
                    } @if (preUploadedFile?.file_type ==='video') {
                    <video controls controlsList="nodownload">
                      <source
                        [src]="preProfileUrl + preUploadedFile.temp_file_name"
                        type="video/mp4"
                      />
                    </video>
                    }
                  </div>
                  }
                  <span class="img-options">
                    <div class="dropdown is-hoverable">
                      <div class="dropdown-trigger">
                        @if (!preUploadedFile) {
                        <i
                          class="fa fa-paperclip"
                          (click)="fileInput.click()"
                        ></i>
                        } @if (preUploadedFile) {
                        <i
                          class="fa fa-paperclip"
                          (click)="removeSelectedFile()"
                        ></i>
                        }
                      </div>
                      <div
                        class="dropdown-menu"
                        id="dropdown-menu4"
                        role="menu"
                      >
                        <div class="dropdown-content">
                          @if (!preUploadedFile) {
                          <a class="dropdown-item">
                            <label class="file-label">
                              <span
                                class="file-label"
                                (click)="fileInput.click()"
                                >Add File or Image</span
                              >
                            </label>
                          </a>
                          } @if (preUploadedFile) {
                          <a
                            class="dropdown-item"
                            (click)="removeSelectedFile()"
                            >Remove File or Image</a
                          >
                          }
                        </div>
                      </div>
                      <input
                        type="file"
                        name="msg-file"
                        style="display: none"
                        (change)="onFileChange($event)"
                        #fileInput
                        accept=".png, .jpg, .jpeg, .mp4"
                      />
                    </div>
                  </span>
                </div>
              </div>
              <div class="field">
                <label class="label" style="font-weight: 500"
                  >Add Comment <span class="required">*</span></label
                >
                <input
                  type="text"
                  class="input"
                  inputFocus
                  placeholder="Add a comment..."
                  rows="1"
                  [(ngModel)]="subPostName"
                  (keyup.enter)="createSubPost(subPostName)"
                  (keypress)="createCommentValid($event)"
                  (keydown)="keyHandleComment($event)"
                />
                <!-- <textarea class="textarea" inputFocus placeholder="Add a comment..." rows="1" [(ngModel)]="subPostName" (keyup.enter)="createSubPost(subPostName)"></textarea> -->
                @if (invalidCommentsError) {
                <p class="help is-danger">This field is required</p>
                }
              </div>
              <div class="field">
                <p class="control has-text-right">
                  <button
                    class="button mar-0-10"
                    (click)="openCreateNewSubPostPanel()"
                  >
                    Cancel
                  </button>
                  <button
                    class="button is-link"
                    (click)="createSubPost(subPostName)"
                  >
                    Save
                  </button>
                </p>
              </div>
            </div>
          </article>
        </div>
        <!-- End -->
      </header>
    </div>
  </div>
  <div class="contents pos-relative">
    <div
      class="notifications scroll-bar"
      infinite-scroll
      [infiniteScrollDistance]="modalScrollDistance"
      [infiniteScrollThrottle]="modalScrollThrottle"
      [scrollWindow]="false"
      (scrolled)="fetchNextSubPostList()"
    >
      @if (subPostDetailList.length > 0) {
      <app-sub-post [subPostList]="subPostDetailList"></app-sub-post>
      }
    </div>
  </div>
</div>
} @if (showNotifyRealTimeUpdate) {
<app-real-update></app-real-update>
}
